import { html, LitElement } from 'lit';

class GithubIcon extends LitElement {
  render() {
    return html`<svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22 0C9.845 0 0 9.845 0 22C0 31.735 6.2975 39.9575 15.0425 42.8725C16.1425 43.065 16.555 42.405 16.555 41.8275C16.555 41.305 16.5275 39.5725 16.5275 37.73C11 38.7475 9.57 36.3825 9.13 35.145C8.8825 34.5125 7.81 32.56 6.875 32.0375C6.105 31.625 5.005 30.6075 6.8475 30.58C8.58 30.5525 9.8175 32.175 10.23 32.835C12.21 36.1625 15.3725 35.2275 16.6375 34.65C16.83 33.22 17.4075 32.2575 18.04 31.7075C13.145 31.1575 8.03 29.26 8.03 20.845C8.03 18.4525 8.8825 16.4725 10.285 14.9325C10.065 14.3825 9.295 12.1275 10.505 9.1025C10.505 9.1025 12.3475 8.525 16.555 11.3575C18.315 10.8625 20.185 10.615 22.055 10.615C23.925 10.615 25.795 10.8625 27.555 11.3575C31.7625 8.4975 33.605 9.1025 33.605 9.1025C34.815 12.1275 34.045 14.3825 33.825 14.9325C35.2275 16.4725 36.08 18.425 36.08 20.845C36.08 29.2875 30.9375 31.1575 26.0425 31.7075C26.84 32.395 27.5275 33.715 27.5275 35.7775C27.5275 38.72 27.5 41.085 27.5 41.8275C27.5 42.405 27.9125 43.0925 29.0125 42.8725C33.3798 41.398 37.1748 38.5911 39.8634 34.8468C42.5519 31.1026 43.9987 26.6095 44 22C44 9.845 34.155 0 22 0Z"
        fill="#494949"
      />
    </svg>`;
  }
}

customElements.define('github-icon', GithubIcon);
